<template>
    <div class="polygon_arrays">
        <!-- This API is can user edit polygon -->
        <div ref="map" class="google_maps" v-if="!errors" :style="{
            height: height,
        }">
        </div>
        <div class="ui error message" v-else>
            <div class="header">
                {{ errors }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ToolGoogleMapsDrawingPolygon",
    props: {
        channel: String,
        positions: {
            type: Array,
            default() {
                // [[25.0835968,121.255406], [25.1091498,121.240364], ...]
                return []
            }
        },
        drawing_modes: {
            type: Array,
            default() {
                // all: ['marker', 'circle', 'polygon', 'polyline', 'rectangle']
                return ['polygon']
            }
        },
        center_position: {
            type: Array,
            default() {
                // [25.0835968, 121.255406]
                return []
            }
        },
        refresh: {
            default: false,
            type: Boolean
        },
        height: {
            default: '400px',
            type: String
        },
        zoom: {
            default: 12,
            type: Number
        },
        type: {
            default: 'terrain',
            type: String
        },
        stroke_color: {
            default: '#FF0000',
            type: String
        },
        stroke_opacity: {
            default: 0.8,
            type: Number
        },
        stroke_weight: {
            default: 3,
            type: Number
        },
        fill_color: {
            default: '#FF0000',
            type: String
        },
        fill_opacity: {
            default: 0.35,
            type: Number
        },
    },
    data() {
        return {
            map: {},
            drawingManager: {},
            all_overlays: [], // 繪製的座標區, 清除上個繪製圖形
            errors: "",
        }
    },
    watch: {
        refresh(value) {
            this.init()
        }
    },
    mounted() {
        this.init()
    },
    computed: {
    },
    methods: {
        async init() {
            var element = this.$refs.map

            try {
                await new Promise(resolve => {
                    if (Array.isArray(this.center_position) && this.center_position.length != 2) {
                        throw 'center_position error'
                    }

                    // 當前地圖位置
                    this.map = new google.maps.Map(element, {
                        center: {
                            lat: this.center_position[0],
                            lng: this.center_position[1],
                        },
                        zoom: this.zoom
                    })
                    resolve()
                })
                await this.set_position_polygon()

                await new Promise(resolve => {
                    this.drawingManager = new google.maps.drawing.DrawingManager({
                        drawingMode: 'polygon',
                        drawingControl: true,
                        drawingControlOptions: {
                            position: google.maps.ControlPosition.TOP_CENTER,
                            drawingModes: ['polygon']
                        },
                    })

                    this.drawingManager.setMap(this.map)
                    resolve()
                })
                await this.set_google_maps_event()
                await new Promise(resolve => {
                    resolve()
                })
            } catch (e) {
                console.log(e)
                this.errors = e
                this.$noty.error(
                    this.errors
                )
            }
            // switch (this.$store.state.language) {
            //     case 'zh-TW':
            //         center_position = {
            //             lat: 23.911035,
            //             lng: 121.058502
            //         }
            //         zoom = 8.46
            //         break
            //     case 'zh-CN':
            //         center_position = {
            //             lat: 30.683674,
            //             lng: 113.436786
            //         }
            //         zoom = 6
            //         break
            //     case 'en-US':
            //         center_position = {
            //             lat: 39.766216,
            //             lng: -99.734738
            //         }
            //         zoom = 5
            //         break
            //     default:
            //
            // }

        },
        set_position_polygon() {
            var triangle_coords = []

            if (Array.isArray(this.positions) && this.positions.length > 1) {
                _.forEach(this.positions, (position) => {
                    triangle_coords.push(
                        {
                            lat: position[0],
                            lng: position[1]
                        }
                    )
                })
                console.log(triangle_coords)
                var bermudaTriangle = new google.maps.Polygon({
                    paths: triangle_coords,
                    strokeColor: this.stroke_color,
                    strokeOpacity: this.stroke_opacity,
                    strokeWeight: this.stroke_weight,
                    fillColor: this.fill_color,
                    fillOpacity: this.fill_opacity,
                })

                bermudaTriangle.setMap(this.map)
            }
            return Promise.resolve()
        },
        set_google_maps_event() {
            // 清除之前畫的圖形
            google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (e) => {
                for (var i=0; i < this.all_overlays.length; i++)
                {
                    this.all_overlays[i].overlay.setMap(null)
                }
                this.all_overlays.push(e)
            })

            google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (polygon) => {
                var array = []
                for (var i = 0;i < polygon.getPath().getLength(); i++) {
                    array.push(
                    	polygon.getPath().getAt(i).toUrlValue(6)
                    )
                }
                console.log(array)
                this.$bus.$emit(this.channel, array)
            })
            return Promise.resolve()
        },
    },
    components: {
    }
}
</script>


<style scoped>
    .google_maps {
        width: 100%;
    }
    .error.message {
        display: block !important;
    }

</style>
